import { useEffect, useRef } from "react";
import { useTaskStore } from "../store/useTaskStore";

/**
 * Component responsible for initializing the tasks store once when the app loads.
 * This component doesn't render anything, it just triggers the initial fetch.
 */
export const TasksInitializer: React.FC = () => {
  const { fetchTasks } = useTaskStore();
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (!hasFetchedRef.current) {
      fetchTasks();
      hasFetchedRef.current = true;
    }
  }, []);

  return null;
};
